import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { MainTimesheet } from "../../class/main-timesheet";
import { Timesheet } from "../../class/timesheet";

@Injectable({
  providedIn: "root",
})
export class AddTimesheetService {
  constructor(private http: HttpClient) { }

  //submit status
  submitTimesheet(mainTimesheetId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/submitTimesheet/` + mainTimesheetId
    );
  }

  submitTimesheetManager(mainTimesheetId: number): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/submitTimesheetManager/` +
      mainTimesheetId
    );
  }

  //mainTimesheet
  findMainTimesheetById(id: number): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/getMainTimesheetById/` + id
    );
  }

  //Timesheet

  addTimesheet(timesheet: Timesheet): Observable<any> {
    console.log('=== HTTP REQUEST : addTimesheet ===');
    console.log('Payload RAW:', timesheet);
    console.log(
    'Payload JSON:',
    JSON.stringify(timesheet, (key, value) => {
      if (value instanceof Date) {
        return value.toISOString();
      }
      return value;
    }, 2)
  );

    return this.http.post<any>(
      `${environment.url}/apiTimesheet/addTimesheet`,
      timesheet
    );
  }


  importTimesheet(timesheet: Timesheet): Observable<any> {
    return this.http.post<any>(
      `${environment.url}/apiTimesheet/import-timesheet`,
      timesheet
    );
  }

  

  updateTimesheetToRemote(timesheet: Timesheet): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/apiTimesheet/editTimesheet`,
      timesheet
    );
  }
  
  fetchTimesheetTByIdFromRemote(id: number): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/gettimesheetbyid/` + id
    );
  }

  //gettimesheet
  fetchTimesheetFromRemote(): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getTimesheetAll`
    );
  }
  //delete
  deleteTimesheetByIdFromRemote(id: number): Observable<any> {
    return this.http.delete(
      `${environment.url}/apiTimesheet/deleteById/` + id,
      { responseType: 'text' }
    );
  }

  getTimesheetByPagging(
    userId: number,
    pageNo: number,
    pageSize: number,
    maintimesheetId: number,
    keyword: string,

    startDate: string,
    endDate: string,
    sortBy: string,
    isAscending: boolean,

  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("maintimesheetId", maintimesheetId);
    if (startDate != null) {
      params = params.append("startDate", startDate);
    }
    if (endDate != null) {
      params = params.append("endDate", endDate);
    }
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    if (pageNo != null) {
      params = params.append("pageNo", pageNo);
    }
    if (pageSize != null) {
      params = params.append("pageSize", pageSize);
    }
    if (sortBy != null) {
      params = params.append("sortBy", sortBy);
    }
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/getAllTimesheetByNamePaging/`,
      { params: params }
    );
  }

  sumWorkingHoursByName(
    maintimesheetId: number,
    keyword: string
  ): Observable<any> {
    let params = new HttpParams();
    params = params.append("maintimesheetId", maintimesheetId);
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    return this.http.get<any>(`${environment.url}/apiTimesheet/sumTimesheet`, {
      params: params,
    });
  }

  AddLeaveTimesheet(maintimesheet: MainTimesheet): Observable<any> {
    return this.http.post<any>(
      `${environment.url}/apiTimesheet/AddMainTimesheet1`,
      maintimesheet
    );
  }

  // getProjectIdByUserId(userId: number): Observable<any> {
  //   let params = new HttpParams();
  //   params = params.append("userId", userId);
  //   return this.http.get<any>(
  //     `${environment.url}/apiTimesheet/getProjectIdByUserId`,
  //     { params: params }
  //   );
  // }

  findTimesheetByDate(
    employeeId: number,
    date: string
  ): Observable<any> {
    return this.http.get<any>(`${environment.url}/apiTimesheet/findTimesheetByDate/${employeeId}/${date}`);
  }

    exportTimesheetTemplate(mainTimesheetId: number): Observable<Blob> {
  return this.http.get(
    `${environment.url}/apiTimesheet/export-template/${mainTimesheetId}`,
    { responseType: 'blob' }
  );
}

  getSumCost(
    id: number,
  ) {
    return this.http.get<any>(`${environment.url}/apiMainTimeSheet/getSumCost/${id}`);
  }

  getSameDateTimesheets(
    employeeId: number,
    transDate: string,
    id: number
  ) {
    let params = new HttpParams();
    params = params.append("employeeId", employeeId);
    params = params.append("transDate", transDate);
    params = params.append("id", id);
    return this.http.get<any>(`${environment.url}/apiTimesheet/getSameDateTimesheets`, { params: params });
  }
}
